import React from 'react';
import PlaidButton from '../PlaidButton';

export default function PlaidReconnectButton ({ accountId }) {
    return (
        <PlaidButton
            solid="false"
            accountId={accountId}
        >
            Re-Connect
        </PlaidButton>
    );
}